import { FC, useContext } from "react"
import './cardkpi.css'
import { useHistory } from "react-router-dom"
import { UserContext } from "../../../Redux/UserContext"
import { BsFillLockFill } from "react-icons/bs";
import { BsFillUnlockFill } from "react-icons/bs";
import { numberFormatter } from "../../../utils/helperFunctions";


export const CardKPI:FC<any> = (props):JSX.Element  => {

    const { id, title, id_plant, kpi1title, kpi1, kpi2, kpi2title, handleOpenScenarioModal, type, anio, cambio_pendiente } = props

    const [state] = useContext(UserContext)

    const history:any = useHistory()

    const renderLock = () => {
        const roles_operativo:any = [1,3,6]
        const roles_estrategico:any = [1,2,6] 
        if(type === 'Operativo' && roles_operativo.includes(state?.rol_id)) {
            if(state?.id_plants?.includes(id_plant)) {
                return <BsFillUnlockFill size={20} />
            }
            return <BsFillLockFill size={20} />
        } else if(type === 'Estratégico' && roles_estrategico.includes(state?.rol_id)) {
            if(state?.id_plants?.includes(id_plant)) {
                return <BsFillUnlockFill size={20} />
            }
            return <BsFillLockFill size={20} />
        } else {
            return <BsFillLockFill size={20} />
        }
    }

    return (
        <div className="card__wrapper" onClick={ type === 'Operativo'? () => history.push(`/operative_scenario/${id}`) : () => handleOpenScenarioModal(id, title, type, anio)}>
           
            <span>
                {
                    type === 'Operativo'?
                    <span></span>
                    :
                    <span>{anio}{cambio_pendiente? '**' : ''}</span>
                }
                
                <span >{title}</span>
                <span >{renderLock()}</span>
            </span>
            <div>
                <div className="card__wrapper-item" >
                    <span>{kpi1title}</span>
                    <span style={kpi1 === 30?{color:'red'}: kpi1 >=25 && kpi1 <30? {color:'orange'} : {}}>{numberFormatter(kpi1)} </span>
                    
                </div>
                
                <div  className="card__wrapper-item">
                    <span>{kpi2title}</span>
                    <span>{numberFormatter(kpi2)}</span>
                </div>
            </div>
            
            {
            kpi1 === 30?
                <small className="card__wrapper-error" >Se ha llegado al número máximo de escenarios por planta.</small>
            :
            kpi1 >=25 && kpi1 <30?
                <small  className="card__wrapper-alert" >Queda poco almacenamiento de escenarios para esta planta.</small>
                :
                false
            }
        </div>
    )
}